import {
    login,
    authInfo,
	loginPhone,
    checkToken
} from '@/serve/user';
export default {
    namespaced: true,
    state: {
        collapse: false,
        token: '',
        isShow: false,
        userInfo: JSON.parse(window.sessionStorage.getItem('ms_userInfo')) || {},
        NavBar: JSON.parse(window.sessionStorage.getItem('NavBar')) || [], // 导航菜单 
        tokenCheckTimer: null,
        modalShow: false
    },
    mutations: {
        SET_COLLAPSE(state, bool) {
            state.collapse = bool
        },
        SET_NAVBAR(state, data) {
            state.NavBar = data
            sessionStorage.setItem('NavBar', JSON.stringify(data))
        },
        SET_TOKEN(state, data) {
            state.token = data
            sessionStorage.setItem('ms_token', data)
        },
        SET_INFO(state, data) {
            state.userInfo = data
            sessionStorage.setItem('ms_userInfo', JSON.stringify(data))
        },
        LOGOUT() {
            console.log("=========logout=========");
            window.sessionStorage.clear();
            window.location.reload();
        },
        SET_SHOW(state) {
            state.isShow = !state.isShow
        },
        SET_TOKEN_TIMER(state, timer) {
            state.tokenCheckTimer = timer;
        },
        CLEAR_TOKEN_TIMER(state) {
            if (state.tokenCheckTimer) {
                clearInterval(state.tokenCheckTimer);
                state.tokenCheckTimer = null;
            }
        },
        SET_MODAL_SHOW(state, data) {
			state.modalShow = data;
		},
    },
    actions: {
        // 登录
        login({
            commit
        }, userInfo) {
            return new Promise((resolve, reject) => {
                login(userInfo).then(res => {
                    if (typeof res.token === 'string') {
                        commit('SET_TOKEN', res.token)
                        authInfo().then(res => {
                            commit('SET_INFO', res)
                            resolve()
                        }).catch(error => {
                            reject(error)
                        })
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
		loginPhone({
            commit
        }, userInfo) {
            return new Promise((resolve, reject) => {
                loginPhone(userInfo).then(res => {
                    if (typeof res.token === 'string') {
                        commit('SET_TOKEN', res.token)
                        authInfo().then(res => {
                            commit('SET_INFO', res)
                            resolve()
                        }).catch(error => {
                            reject(error)
                        })
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        startTokenPolling({ commit, dispatch }) {
            commit('CLEAR_TOKEN_TIMER'); // 防止多个定时器

            const INTERVAL = 10 * 1000;
            const timer = setInterval(async () => {
                try {
                    const res = await checkToken();
                    if (res && !res.ok) {
                        console.log('======token无效=======');
                        commit('SET_MODAL_SHOW', true);                       
                        commit('CLEAR_TOKEN_TIMER');
                        commit('LOGOUT'); 
                    } else if(res){
                        console.log('======token有效=======');
                    }else{
                        console.log('======token检查响应异常=======');
                    }
                } catch (err) {
                    console.error('检查 token 失败', err);
                }
            }, INTERVAL);

            commit('SET_TOKEN_TIMER', timer);
        },
        stopTokenPolling({ commit }) {
            commit('CLEAR_TOKEN_TIMER');
        },
    }
}